import React from 'react';
import LendiBot from '@lendi-ui/icon/LendiBot';
import DomainBot from '@lendi-ui/icon/DomainBot';
import AussieBot from '@lendi-ui/icon/AussieBot';
import { Brand, getBrandFromHostname } from '@lendi/lala-utils';
export var BotIcon = function () {
    var brand = getBrandFromHostname();
    switch (brand) {
        case Brand.Aussie:
            return React.createElement(AussieBot, { color: "shade.0", height: "1.5em", width: "1.5em" });
        case Brand.Domain:
            return React.createElement(DomainBot, { height: "1.5em", width: "1.5em" });
        case Brand.Lendi:
        default:
            return React.createElement(LendiBot, { color: "shade.0", height: "1.5em", width: "1.5em" });
    }
};
//# sourceMappingURL=index.js.map